export const CLUBS = {
  country5: {
      league1e: {
          clubSPA1a: {name: 'Barcelona', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubSPA2a: {name: 'Real Madrid', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubSPA3a: {name: 'Real Sociedad', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubSPA4a: {name: 'Atletic Club', manager:"Villian Caragher", city:"Catalonia"}, 
          clubSPA5a: {name: 'Atletico Madrid', manager:"Peter Silas", city:"Catalonia"}, 
          clubSPA6a: {name: 'Ral Betis', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubSPA7a: {name: 'Osasuna', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubSPA8a: {name: 'Rayo Vallecano', manager:"Williams Serko", city:"Catalonia"}, 
          clubSPA9a: {name: 'Villareal', manager:"Craig Rentio", city:"Catalonia"}, 
          clubSPA10a: {name: 'Valencia', manager:"Adonis Greece", city:"Catalonia"}, 
          clubSPA11a: {name: 'Mallorca', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubSPA12a: {name: 'Valladolid', manager:"Hanna Scott", city:"Catalonia"}, 
          clubSPA13a: {name: 'Girona', manager:"Peterson Davis", city:"Catalonia"}, 
          clubSPA14a: {name: 'Almeria', manager:"John Bello", city:"Catalonia"}, 
          clubSPA15a: {name: 'Gatafe', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubSPA16a: {name: 'Espanyol', manager:"James Gary", city:"Catalonia"},
          clubSPA17a: {name: 'Celta Vigo', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubSPA18a: {name: 'Sevilla', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubSPA19a: {name: 'Cadiz', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubSPA20a: {name: 'Elche', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league2e: {
          clubSPA1b: {name: 'Alaves', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubSPA2b: {name: 'Las Palmas', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubSPA3b: {name: 'Burgos', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubSPA4b: {name: 'Levante', manager:"Villian Caragher", city:"Catalonia"}, 
          clubSPA5b: {name: 'Eibar', manager:"Peter Silas", city:"Catalonia"}, 
          clubSPA6b: {name: 'FC Catergena', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubSPA7b: {name: 'Huesca', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubSPA8b: {name: 'Granada', manager:"Williams Serko", city:"Catalonia"}, 
          clubSPA9b: {name: 'Albacete', manager:"Craig Rentio", city:"Catalonia"}, 
          clubSPA10b: {name: 'Andorra', manager:"Adonis Greece", city:"Catalonia"}, 
          clubSPA11b: {name: 'Sporting Gijon', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubSPA12b: {name: 'Leganes', manager:"Hanna Scott", city:"Catalonia"}, 
          clubSPA13b: {name: 'Vilareal B', manager:"Peterson Davis", city:"Catalonia"}, 
          clubSPA14b: {name: 'Racing', manager:"John Bello", city:"Catalonia"}, 
          clubSPA15b: {name: 'Tenerife', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubSPA16b: {name: 'Zaragoza', manager:"James Gary", city:"Catalonia"},
          clubSPA17b: {name: 'Oviedo', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubSPA18b: {name: 'Ponferradina', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubSPA19b: {name: 'Lugo', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubSPA20b: {name: 'Mirandes', manager:"Villian Caragher", city:"Catalonia"}, 
          clubSPA21b: {name: 'Ibiza', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubSPA22b: {name: 'Malaga', manager:"Villian Caragher", city:"Catalonia"}, 
      }
  },
  country1: {
      league1a: {
          clubENG1a: {name: 'Arsenal', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG2a: {name: 'Man City', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG3a: {name: 'Newcastle', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG4a: {name: 'Tottenham', manager:"Villian Caragher", city:"Catalonia"}, 
          clubENG5a: {name: 'Man United', manager:"Peter Silas", city:"Catalonia"}, 
          clubENG6a: {name: 'Liverpool', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubENG7a: {name: 'Brighton', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubENG8a: {name: 'Chelsea', manager:"Williams Serko", city:"Catalonia"}, 
          clubENG9a: {name: 'Fulham', manager:"Craig Rentio", city:"Catalonia"}, 
          clubENG10a: {name: 'Brentford', manager:"Adonis Greece", city:"Catalonia"}, 
          clubENG11a: {name: 'Crystal Palace', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubENG12a: {name: 'Aston Villa', manager:"Hanna Scott", city:"Catalonia"}, 
          clubENG13a: {name: 'Leicester City', manager:"Peterson Davis", city:"Catalonia"}, 
          clubENG14a: {name: 'Bournmouth', manager:"John Bello", city:"Catalonia"}, 
          clubENG15a: {name: 'Leeds City', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubENG16a: {name: 'West Ham', manager:"James Gary", city:"Catalonia"},
          clubENG17a: {name: 'Everton', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG18a: {name: 'Nottinham Forest', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG19a: {name: 'Southampton', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG20a: {name: 'Wolves', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league2a: {
          clubENG1b: {name: 'Burnley', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG2b: {name: 'Sheffield Utd', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG3b: {name: 'Blackburn Rovers', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG4b: {name: 'Watford', manager:"Villian Caragher", city:"Catalonia"}, 
          clubENG5b: {name: 'Norwich City', manager:"Peter Silas", city:"Catalonia"}, 
          clubENG6b: {name: 'Millwall', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubENG7b: {name: 'QPR', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubENG8b: {name: 'Swansea', manager:"Williams Serko", city:"Catalonia"}, 
          clubENG9b: {name: 'Preston', manager:"Craig Rentio", city:"Catalonia"}, 
          clubENG10b: {name: 'Luton Town', manager:"Adonis Greece", city:"Catalonia"}, 
          clubENG11b: {name: 'Coventry', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubENG12b: {name: 'Reading', manager:"Hanna Scott", city:"Catalonia"}, 
          clubENG13b: {name: 'Birmingham', manager:"Peterson Davis", city:"Catalonia"}, 
          clubENG14b: {name: 'Middlebrough', manager:"John Bello", city:"Catalonia"}, 
          clubENG15b: {name: 'Sunderland', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubENG16b: {name: 'Rotherham', manager:"James Gary", city:"Catalonia"},
          clubENG17b: {name: 'Stoke city', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG18b: {name: 'Bristol City', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG19b: {name: 'Cadiff City', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG20b: {name: 'Hull City', manager:"Villian Caragher", city:"Catalonia"}, 
          clubENG21b: {name: 'West Brom', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG22b: {name: 'Wigan Athletic', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG23b: {name: 'Blackpool', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG24b: {name: 'Hudersfield', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league4a: {
          clubENG1d: {name: 'Burnley2', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG2d: {name: 'Sheffield Utd2', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG3d: {name: 'Blackburn Rovers2', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG4d: {name: 'Watford2', manager:"Villian Caragher", city:"Catalonia"}, 
          clubENG5d: {name: 'Norwich City2', manager:"Peter Silas", city:"Catalonia"}, 
          clubENG6d: {name: 'Millwall2', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubENG7d: {name: 'QPR2', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubENG8d: {name: 'Swansea2', manager:"Williams Serko", city:"Catalonia"}, 
          clubENG9d: {name: 'Preston2', manager:"Craig Rentio", city:"Catalonia"}, 
          clubENG10d: {name: 'Luton Town2', manager:"Adonis Greece", city:"Catalonia"}, 
          clubENG11d: {name: 'Coventry2', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubENG12d: {name: 'Reading2', manager:"Hanna Scott", city:"Catalonia"}, 
          clubENG13d: {name: 'Birmingham2', manager:"Peterson Davis", city:"Catalonia"}, 
          clubENG14d: {name: 'Middlebrough2', manager:"John Bello", city:"Catalonia"}, 
          clubENG15d: {name: 'Sunderland2', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubENG16d: {name: 'Rotherham2', manager:"James Gary", city:"Catalonia"},
          clubENG17d: {name: 'Stoke city2', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG18d: {name: 'Bristol City2', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG19d: {name: 'Cadiff City2', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG20d: {name: 'Hull City2', manager:"Villian Caragher", city:"Catalonia"}, 
          clubENG21d: {name: 'West Brom2', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubENG22d: {name: 'Wigan Athletic2', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubENG23d: {name: 'Blackpool2', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubENG24d: {name: 'Hudersfield2', manager:"Villian Caragher", city:"Catalonia"}, 
      },
  },
  country2: {
      league1b: {
          clubFRA1a: {name: 'PSG', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA2a: {name: 'Lens', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubFRA3a: {name: 'Stade Rennes', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubFRA4a: {name: 'Marseille', manager:"Villian Caragher", city:"Catalonia"}, 
          clubFRA5a: {name: 'Lorient', manager:"Peter Silas", city:"Catalonia"}, 
          clubFRA6a: {name: 'Monaco', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubFRA7a: {name: 'LOSC', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubFRA8a: {name: 'Lyon', manager:"Williams Serko", city:"Catalonia"}, 
          clubFRA9a: {name: 'Nice', manager:"Craig Rentio", city:"Catalonia"}, 
          clubFRA10a: {name: 'Clermont Foot', manager:"Adonis Greece", city:"Catalonia"}, 
          clubFRA11a: {name: 'Reims', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubFRA12a: {name: 'Toulouse', manager:"Hanna Scott", city:"Catalonia"}, 
          clubFRA13a: {name: 'Troyes', manager:"Peterson Davis", city:"Catalonia"}, 
          clubFRA14a: {name: 'Montpellier', manager:"John Bello", city:"Catalonia"}, 
          clubFRA15a: {name: 'Nantes', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubFRA16a: {name: 'Brest', manager:"James Gary", city:"Catalonia"},
          clubFRA17a: {name: 'Auxerre', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA18a: {name: 'Ajaccio', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubFRA19a: {name: 'Stasbourg', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubFRA20a: {name: 'Angers', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league2b: {
          clubFRA1b: {name: 'La Havre', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA2b: {name: 'Bordeaux', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubFRA3b: {name: 'Sochaux', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubFRA4b: {name: 'Grenoble Foot', manager:"Villian Caragher", city:"Catalonia"}, 
          clubFRA5b: {name: 'Caen', manager:"Peter Silas", city:"Catalonia"}, 
          clubFRA6b: {name: 'Valenciennes', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubFRA7b: {name: 'Amiens SC', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubFRA8b: {name: 'Metz', manager:"Williams Serko", city:"Catalonia"}, 
          clubFRA9b: {name: 'Pau', manager:"Craig Rentio", city:"Catalonia"}, 
          clubFRA10b: {name: 'Stade Laval', manager:"Adonis Greece", city:"Catalonia"}, 
          clubFRA11b: {name: 'Guingamp', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubFRA12b: {name: 'Paris FC', manager:"Hanna Scott", city:"Catalonia"}, 
          clubFRA13b: {name: 'Quivelly-Rouen', manager:"Peterson Davis", city:"Catalonia"}, 
          clubFRA14b: {name: 'Bastia', manager:"John Bello", city:"Catalonia"}, 
          clubFRA15b: {name: 'Annecy', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubFRA16b: {name: 'Nimes', manager:"James Gary", city:"Catalonia"},
          clubFRA17b: {name: 'Dijon', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA18b: {name: 'Rodez', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubFRA19b: {name: 'Niort', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubFRA20b: {name: 'St-Etienne', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league3b: {
          clubFRA1c: {name: 'Concarneau', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA2c: {name: 'Versailles', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubFRA3c: {name: 'Martigues', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubFRA4c: {name: 'Dunkerque', manager:"Villian Caragher", city:"Catalonia"}, 
          clubFRA5c: {name: 'Red Star', manager:"Peter Silas", city:"Catalonia"}, 
          clubFRA6c: {name: 'Cholet', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubFRA7c: {name: 'US Orleans', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubFRA8c: {name: 'Villefranche', manager:"Williams Serko", city:"Catalonia"}, 
          clubFRA9c: {name: 'Chateauroux', manager:"Craig Rentio", city:"Catalonia"}, 
          clubFRA10c: {name: 'Nancy', manager:"Adonis Greece", city:"Catalonia"}, 
          clubFRA11c: {name: 'Le Mans', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubFRA12c: {name: 'FBBP 01', manager:"Hanna Scott", city:"Catalonia"}, 
          clubFRA13c: {name: 'Avranches', manager:"Peterson Davis", city:"Catalonia"}, 
          clubFRA14c: {name: 'Sedan', manager:"John Bello", city:"Catalonia"}, 
          clubFRA15c: {name: 'Gobelins', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubFRA16c: {name: 'Le Puy', manager:"James Gary", city:"Catalonia"},
          clubFRA17c: {name: 'Bastia-Borgo', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubFRA18c: {name: 'Stade Briochin', manager:"Carlo Ancellloti", city:"Catalonia"}, 
        //   clubFRA19c: {name: 'Psg 3', manager:"Xavi hernandes", city:"Catalonia"}, 
        //   clubFRA20c: {name: 'Monaco 3', manager:"Carlo Ancellloti", city:"Catalonia"}, 
      }
  },
  country3: {
      league1c: {
          clubGER1a: {name: 'Bayern', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubGER2a: {name: 'SC Freiburg', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubGER3a: {name: 'RB Leipzig', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubGER4a: {name: 'Eintracht Frankfurt', manager:"Villian Caragher", city:"Catalonia"}, 
          clubGER5a: {name: 'Union Berlin', manager:"Peter Silas", city:"Catalonia"}, 
          clubGER6a: {name: 'Dortmund', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubGER7a: {name: 'wolfburg', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubGER8a: {name: 'Mochengladbach', manager:"Williams Serko", city:"Catalonia"}, 
          clubGER9a: {name: 'Werder', manager:"Craig Rentio", city:"Catalonia"}, 
          clubGER10a: {name: 'Mainz', manager:"Adonis Greece", city:"Catalonia"}, 
          clubGER11a: {name: 'Hoffeinherm', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubGER12a: {name: 'Leverkusen', manager:"Hanna Scott", city:"Catalonia"}, 
          clubGER13a: {name: 'Cologne', manager:"Peterson Davis", city:"Catalonia"}, 
          clubGER14a: {name: 'Ausburg', manager:"John Bello", city:"Catalonia"}, 
          clubGER15a: {name: 'Hertha Berlin', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubGER16a: {name: 'VFB Stuttgart', manager:"James Gary", city:"Catalonia"},
          clubGER17a: {name: 'Vfl Bochum', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubGER18a: {name: 'Schalke', manager:"Xavi hernandes", city:"Catalonia"}, 
      },
      league2c: {
          clubGER1b: {name: 'Darmstadt', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubGER2b: {name: 'Hamburger SV', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubGER3b: {name: 'Heindenheim', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubGER4b: {name: 'Kaiserslautern', manager:"Villian Caragher", city:"Catalonia"}, 
          clubGER5b: {name: 'Hannover 96', manager:"Peter Silas", city:"Catalonia"}, 
          clubGER6b: {name: 'Paderborn', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubGER7b: {name: 'Dusseldorf', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubGER8b: {name: 'Holstein Kiel', manager:"Williams Serko", city:"Catalonia"}, 
          clubGER9b: {name: 'Hansa', manager:"Craig Rentio", city:"Catalonia"},  
          clubGER10b: {name: 'Greuth Furth', manager:"Craig Rentio", city:"Catalonia"}, 
          clubGER11b: {name: 'Nurnberg', manager:"Adonis Greece", city:"Catalonia"}, 
          clubGER12b: {name: 'Jahn Regens...', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubGER13b: {name: 'Karlruher', manager:"Hanna Scott", city:"Catalonia"}, 
          clubGER14b: {name: 'Eintract Brau...', manager:"Peterson Davis", city:"Catalonia"}, 
          clubGER15b: {name: 'FC St. Pauli', manager:"John Bello", city:"Catalonia"}, 
          clubGER16b: {name: 'Amenia', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubGER17b: {name: '1. FC Magdeb...', manager:"James Gary", city:"Catalonia"},
          clubGER18b: {name: 'SV Sandhausen', manager:"Xavi hernandes", city:"Catalonia"}, 
      },
      league3c: {
          clubGER1c: {name: 'SV Elverberg', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubGER2c: {name: 'Saarbrucken', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubGER3c: {name: 'Wehen Wiesburg', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubGER4c: {name: 'Ingolstadt', manager:"Villian Caragher", city:"Catalonia"}, 
          clubGER5c: {name: 'Freiburg', manager:"Peter Silas", city:"Catalonia"}, 
          clubGER6c: {name: '1860 Munich', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubGER7c: {name: 'Viktoria Koln', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubGER8c: {name: 'SV Waldhof', manager:"Williams Serko", city:"Catalonia"}, 
          clubGER9c: {name: 'Dynamo', manager:"Craig Rentio", city:"Catalonia"}, 
          clubGER10c: {name: 'Vfl Osnabruck', manager:"Adonis Greece", city:"Catalonia"}, 
          clubGER11c: {name: 'MSV Duisburg', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubGER12c: {name: 'Verl', manager:"Hanna Scott", city:"Catalonia"}, 
          clubGER13c: {name: 'Essen', manager:"Peterson Davis", city:"Catalonia"}, 
          clubGER14c: {name: 'Borussia Dortmund', manager:"John Bello", city:"Catalonia"}, 
          clubGER15c: {name: 'Hallescher', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubGER16c: {name: 'VFB Oldenburg', manager:"James Gary", city:"Catalonia"},
          clubGER17c: {name: 'Zwickau', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubGER18c: {name: 'Erzgebirge', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubGER19c: {name: 'SV Meppen', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubGER20c: {name: 'Bayreuth', manager:"Carlo Ancellloti", city:"Catalonia"}, 
      }
  },
  country4: {
      league1d: {
          clubITA1a: {name: 'Napoli', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA2a: {name: 'Milan', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA3a: {name: 'Juventus', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA4a: {name: 'Lazio', manager:"Villian Caragher", city:"Catalonia"}, 
          clubITA5a: {name: 'Inter Milan', manager:"Peter Silas", city:"Catalonia"}, 
          clubITA6a: {name: 'Atalanta', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubITA7a: {name: 'Roma', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubITA8a: {name: 'Undinese', manager:"Williams Serko", city:"Catalonia"}, 
          clubITA9a: {name: 'Torino', manager:"Craig Rentio", city:"Catalonia"}, 
          clubITA10a: {name: 'Florentina', manager:"Adonis Greece", city:"Catalonia"}, 
          clubITA11a: {name: 'Bologna', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubITA12a: {name: 'Seleritana', manager:"Hanna Scott", city:"Catalonia"}, 
          clubITA13a: {name: 'Empoli', manager:"Peterson Davis", city:"Catalonia"}, 
          clubITA14a: {name: 'Monza', manager:"John Bello", city:"Catalonia"}, 
          clubITA15a: {name: 'Sassuolo', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubITA16a: {name: 'Lecce', manager:"James Gary", city:"Catalonia"},
          clubITA17a: {name: 'Spezia', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA18a: {name: 'Cromonese', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA19a: {name: 'Sampdoria', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA20a: {name: 'Verona', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league2d: {
          clubITA1b: {name: 'Frocinone', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA2b: {name: 'Reggina', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA3b: {name: 'Genoa', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA4b: {name: 'Parma', manager:"Villian Caragher", city:"Catalonia"}, 
          clubITA5b: {name: 'Ternana', manager:"Peter Silas", city:"Catalonia"}, 
          clubITA6b: {name: 'Bari', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubITA7b: {name: 'Brescia', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubITA8b: {name: 'Sudtirol', manager:"Williams Serko", city:"Catalonia"}, 
          clubITA9b: {name: 'Ascoli', manager:"Craig Rentio", city:"Catalonia"}, 
          clubITA10b: {name: 'Cagliari', manager:"Adonis Greece", city:"Catalonia"}, 
          clubITA11b: {name: 'Pisa', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubITA12b: {name: 'SPAL', manager:"Hanna Scott", city:"Catalonia"}, 
          clubITA13b: {name: 'Palermo', manager:"Peterson Davis", city:"Catalonia"}, 
          clubITA14b: {name: 'Cittadella', manager:"John Bello", city:"Catalonia"}, 
          clubITA15b: {name: 'Modena', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubITA16b: {name: 'Benevento', manager:"James Gary", city:"Catalonia"},
          clubITA17b: {name: 'Cosenza', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA18b: {name: 'Como', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA19b: {name: 'Venezia', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA20b: {name: 'Perugia', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league3d: {
          clubITA1c: {name: 'Pordenone', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA2c: {name: 'Renate', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA3c: {name: 'Novara', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA4c: {name: 'Feralpisalo', manager:"Villian Caragher", city:"Catalonia"}, 
          clubITA5c: {name: 'Lecco', manager:"Peter Silas", city:"Catalonia"}, 
          clubITA6c: {name: 'Pro Sesto', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubITA7c: {name: 'Vicenza', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubITA8c: {name: 'Juventus Next...', manager:"Williams Serko", city:"Catalonia"}, 
          clubITA9c: {name: 'Padova', manager:"Craig Rentio", city:"Catalonia"}, 
          clubITA10c: {name: 'Union Arzigna...', manager:"Adonis Greece", city:"Catalonia"}, 
          clubITA11c: {name: 'Pergolette', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubITA12c: {name: 'Pro Patria', manager:"Hanna Scott", city:"Catalonia"}, 
          clubITA13c: {name: 'Pro Vercelli', manager:"Peterson Davis", city:"Catalonia"}, 
          clubITA14c: {name: 'Sangiuliano', manager:"John Bello", city:"Catalonia"}, 
          clubITA15c: {name: 'Albinoleffe', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubITA16c: {name: 'Mantova', manager:"James Gary", city:"Catalonia"},
          clubITA17c: {name: 'Trento', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA18c: {name: 'Triestina', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA19c: {name: 'Piacenza', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA20c: {name: 'Virtus Verona', manager:"Villian Caragher", city:"Catalonia"}, 
      },
      league4d: {
          clubITA1d: {name: 'Sestri Levante', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA2d: {name: 'Sanremo', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA3d: {name: 'Vado', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA4d: {name: 'Gozzano', manager:"Villian Caragher", city:"Catalonia"}, 
          clubITA5d: {name: 'Bra', manager:"Peter Silas", city:"Catalonia"}, 
          clubITA6d: {name: 'Ligorna', manager:"Ricardo Donnil", city:"Catalonia",}, 
          clubITA7d: {name: 'Legnano', manager:"Hercules Albertio", city:"Catalonia"}, 
          clubITA8d: {name: 'Casale', manager:"Williams Serko", city:"Catalonia"}, 
          clubITA9d: {name: 'Fezzanese', manager:"Craig Rentio", city:"Catalonia"}, 
          clubITA10d: {name: 'Asti', manager:"Adonis Greece", city:"Catalonia"}, 
          clubITA11d: {name: 'Castellanzese', manager:"Miliano Pelle", city:"Catalonia"}, 
          clubITA12d: {name: 'Derthona', manager:"Hanna Scott", city:"Catalonia"}, 
          clubITA13d: {name: 'Castanese', manager:"Peterson Davis", city:"Catalonia"}, 
          clubITA14d: {name: 'Chieri', manager:"John Bello", city:"Catalonia"}, 
          clubITA15d: {name: 'PDHAE', manager:"Emiliander Recce", city:"Catalonia"}, 
          clubITA16d: {name: 'Pinerolo', manager:"James Gary", city:"Catalonia"},
          clubITA17d: {name: 'Stresa', manager:"Xavi hernandes", city:"Catalonia"}, 
          clubITA18d: {name: 'Borgosesia', manager:"Carlo Ancellloti", city:"Catalonia"}, 
          clubITA19d: {name: 'Chisola', manager:"Mauricio Pochetino", city:"Catalonia"}, 
          clubITA20d: {name: 'Fossano', manager:"Villian Caragher", city:"Catalonia"}, 
      }
    },
}
